module.exports = __webpack_public_path__ + "static/media/wp_3.7271b443.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wp_3.png
// module id = 32
// module chunks = 0